import { render, staticRenderFns } from "./phoneStripForm.vue?vue&type=template&id=1bd1d442&"
import script from "./phoneStripForm.vue?vue&type=script&lang=js&"
export * from "./phoneStripForm.vue?vue&type=script&lang=js&"
import style0 from "./phoneStripForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports